type FabCancelTicketProps = {
    className?: string;
    size?: number;
    fill?: string;
};

const FabCancelTicket = ({className, size = 22, fill = 'currentColor'}: FabCancelTicketProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="28 28 24 24"
        fill="none"
        stroke={fill}
        strokeWidth={1.65}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden
    >
        <path d="M40.0002 49.1667C45.0628 49.1667 49.1668 45.0627 49.1668 40C49.1668 34.9374 45.0628 30.8334 40.0002 30.8334C34.9376 30.8334 30.8335 34.9374 30.8335 40C30.8335 45.0627 34.9376 49.1667 40.0002 49.1667Z" />
        <path d="M42.75 37.25L37.25 42.75" />
        <path d="M37.25 37.25L42.75 42.75" />
    </svg>
);

export default FabCancelTicket;
